/**
 * API helper — routes all fetch calls to the Cloud Run backend
 * instead of trying to go through Firebase Hosting (which can't proxy).
 */
import { auth } from './firebase';

export const API_BASE: string = (process.env.VITE_API_BASE as string) || '';

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

/**
 * fetch() against the backend that attaches the signed-in user's Firebase ID token.
 *
 * Required for endpoints that act on the stored Google connection
 * (/api/workspace/*). The server now verifies the caller instead of serving
 * whoever happens to ask while tokens are on file.
 */
export async function authFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers || {});
  const user = auth.currentUser;
  if (user) {
    try {
      const token = await user.getIdToken();
      headers.set('Authorization', `Bearer ${token}`);
    } catch (err) {
      console.error('authFetch: unable to obtain ID token', err);
    }
  }
  return fetch(apiUrl(path), { ...init, headers });
}

export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  return fetch(apiUrl(path), init);
}
